import {API_URL} from "../../config";

export const GET_PLANS_URL = `${API_URL}/product`;